export const tipColumns = [
  { title: '日计划开工数', column: 'dailyPlanStartWorkQuantity', tip: '计划开始时间=日期' },
  { title: '准时开工数', column: 'onTimeStartWorkQuantity', tip: '扫码开工时间=日期' },
  { title: '准时开工率', column: 'onTimeStartWorkRateStr', tip: '准时开工数/日计划开工数' },
  { title: '及时开工数', column: 'timelyStartWorkQuantity', tip: '扫码开工时间≤日期' },
  { title: '及时开工率', column: 'timelyStartWorkRateStr', tip: '及时开工数/日计划开工数' },
  { title: '当日实际完工数', column: 'currentTodayActualCompleteQuantity', tip: '完工时间=日期' },
  { title: '计划内完工数', column: 'planCompleteQuantity', tip: '日计划完成时间=日期' },
  { title: '提前完工数', column: 'advanceCompleteQuantity', tip: '日计划完成时间＞日期' },
  { title: '延期完工数', column: 'delayCompleteQuantity', tip: '日计划完成时间＜日期' },
  { title: '当日实际入库数', column: 'currentTodayActualReceiveQuantity', tip: '计划内入库+提前入库+延期入库' },
  { title: '计划内入库数', column: 'planReceiveQuantity', tip: '日计划完成时间=日期' },
  { title: '计划内提前入库数', column: 'planAdvanceReceiveQuantity', tip: '计划内工单，入库时间<日期' },
  { title: '提前入库数', column: 'advanceReceiveQuantity', tip: '日计划完成时间＞日期' },
  { title: '延期入库数', column: 'delayReceiveQuantity', tip: '日计划完成时间＜日期' },
  { title: '日计划分母', column: 'dailyPlanDenominator', tip: '当天未完成数量交期的剩余数量' },
  { title: '日计划订单完成率', column: 'dailyPlanAchievementRateStr', tip: '当天入库数/当天未完成数量交期的剩余数量' },
  { title: '一次达交需求数', column: 'deliveryRequireQuantity', tip: '考核交期=一次达交考核时间' },
  { title: '一次达交达成数', column: 'deliveryReceiveQuantity', tip: '一次达交时间=日期 的订单已入库套数' },
  { title: '一次达交率', column: 'deliveryRateStr', tip: '一次达交达成率/一次达交需求数' },
  { title: '调整后考核达交需求数', column: 'adjustAssessmentRequireQuantity', tip: '变更后考核交期=日期 的计划数' },
  { title: '调整后考核达交达成数', column: 'adjustAssessmentReceiveQuantity', tip: '变更后考核交期=日期 的订单入库套数' },
  { title: '综合达交率', column: 'comprehensiveDeliveryRateStr', tip: '调整后考核达交达成数/调整后考核达交需求数' },
  { title: '日计划齐套数', column: 'dailyPlanKittingQuantity', tip: '日计划开始时间=日期，其中订单齐套的套数' },
  { title: '日计划齐套率', column: 'dailyPlanKittingRateStr', tip: '日计划齐套数/日计划开工数' },
  { title: '日入库数', column: 'dailyInventoryQuantity', tip: '计划内入库数+提前入库数+延期入库数' },
  { title: '日工单变更套数', column: 'dailyWorkOrderChangeQuantity', tip: '当日发起工单考核交期变更的订单套数' },
  { title: '工单变更通过套数', column: 'dailyWorkOrderChangePassQuantity', tip: '当日发起工单考核交期变更的订单套数中，通过审核的订单套数' },
  { title: '欠产数', column: 'shortageProductQuantity', tip: '一次考核交期≤所选择的日期 的订单中，尚未入库的套数' }
]
